// eslint-disable-next-line @typescript-eslint/no-namespace -- grandfathered; new code uses plain module exports
export namespace Analytics {
	export function trackEvent(action: string, category: string, value?: number) {
		// Intentionally left blank for future integration with analytics services
		// In the past we tracked events with Google Analytics here
	}
}
